import { FC } from 'react'
// types
import { ChildrenProps } from '../../types/generalType'

type Props = ChildrenProps

const Main: FC<Props> = ({ children }) => {
  return (
    <main className='flex-1 grow p-8 bg-neutral-50 text-gray-400 max-h-[calc(100vh-4rem)] overflow-y-auto scrollbar'>
      <div className='h-auto'>{children}</div>
    </main>
  )
}

export default Main
